// [NEED TO BE FIX] need to fix as per need
export function useRouteMatch({path, exact}) {
return path === exact
}